module.exports = __webpack_public_path__ + "img/cross.dd1ad25b.svg";